import { Node, mergeAttributes } from '@tiptap/react';

export const Quote = Node.create({
  name: 'quote',

  content: 'text*',

  defining: true,

  marks: '',

  parseHTML() {
    return [
      {
        tag: 'blockquote',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'blockquote',
      mergeAttributes(HTMLAttributes, { class: `node-${this.name}` }),
      0,
    ];
  },

  addKeyboardShortcuts() {
    return {
      Backspace: () => false,
    };
  },
});

export default Quote;
